export default {
  'walletaddress.form.title': 'Bind merchant wallet address',
  'walletaddress.remove.title': 'Delete merchant wallet address?',
  'walletaddress.status.pending': 'applying',
  'walletaddress.status.success': 'used',
};